







































import { Component, Inject, Vue } from "vue-property-decorator";
import { ITicketsProvider } from "@/models/providers/tickets";

@Component({
  components: {
    "ticket-inbox-table-row": () =>
      import("@/components/app/global/tickets/ticketInboxTableRow.vue")
  }
})
export default class InboxTable extends Vue {
  // Inject

  @Inject({ from: "ticketsProvider" })
  public readonly $ticketsProvider!: () => ITicketsProvider;

  // Computed

  public get ticketsProvider() {
    return this.$ticketsProvider();
  }

  public get table() {
    const tp = this.ticketsProvider;
    return {
      data: tp.tickets,
      total: tp.total,
      loading: tp.isLoading && !tp.isAutoRefreshing,
      paginated: tp.tickets.length !== 0 && tp.limit < tp.total,
      page: tp.page
    };
  }
}
